import { QRCodeCanvas } from "qrcode.react";

export interface DisplayResult {
  id: string;
  resultUrl: string;
  qrPayload: string;
  templateName?: string;
}

export default function ResultCard({
  result, templateName, onReset, resetLabel = "完成 · 返回生成台", resetHint = "如要生成新的一张,请重新选择模板并上传自拍(会再次计费)。",
}: {
  result: DisplayResult;
  templateName?: string;
  onReset: () => void;
  resetLabel?: string;
  resetHint?: string;
}) {
  // 二维码 payload 是 API 返回的公开下载页 URL。游客扫码后打开成品页,长按保存。
  const qrValue = result.qrPayload;
  return (
    <div className="bg-white rounded-xl border border-slate-200 p-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
        <div>
          <div className="text-xs text-slate-400 uppercase tracking-wide mb-2">生成成功</div>
          <div className="text-lg font-semibold text-slate-800 mb-1">{templateName || result.templateName || "换脸大片"}</div>
          <div className="text-xs text-slate-400">记录 {result.id}</div>
          <div className="mt-4 rounded-lg bg-slate-100 overflow-hidden">
            <img src={result.resultUrl} alt="result" className="w-full h-auto" />
          </div>
        </div>
        <div className="space-y-4">
          <div className="flex items-center justify-center">
            <div className="bg-white p-4 rounded-lg border border-slate-200">
              <QRCodeCanvas value={qrValue} size={220} level="M" includeMargin />
            </div>
          </div>
          <div className="text-xs text-slate-500 text-center leading-relaxed">
            请游客用微信「扫一扫」打开照片页<br />
            <span className="text-slate-400">打开后长按图片保存到相册</span>
          </div>
          <button
            onClick={onReset}
            className="w-full px-4 py-2.5 bg-slate-100 text-slate-700 rounded-lg text-sm font-medium hover:bg-slate-200"
          >
            {resetLabel}
          </button>
          {resetHint && <p className="text-[11px] text-slate-400 text-center">{resetHint}</p>}
        </div>
      </div>
    </div>
  );
}
